<template>
  <div>
    <h1>Lista de Feather Icons</h1>
    <!-- Campo de busca -->
    <input
      v-model="search"
      type="text"
      placeholder="Digite o nome do ícone"
      class="search-input"
    />

    <!-- Contêiner de ícones -->
    <div class="icons-container">
      <div
        v-for="(IconComponent, name) in filteredIcons"
        :key="name"
        class="icon-item"
      >
        <!-- Renderizando o ícone como componente -->
        <component :is="IconComponent" size="32" />
        <!-- Nome do ícone -->
        <p class="icon-name">{{ name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as icons from "vue-feather-icons";

export default {
  name: "FeatherIconsList",
  data() {
    return {
      search: "", // Valor da pesquisa
      icons, // Todos os ícones importados
    };
  },
  computed: {
    filteredIcons() {
      // Retorna apenas os ícones que correspondem à busca
      const searchLower = this.search.toLowerCase();
      return Object.entries(this.icons).reduce((result, [name, IconComponent]) => {
        if (name.toLowerCase().includes(searchLower)) {
          result[name] = IconComponent;
        }
        return result;
      }, {});
    },
  },
};
</script>

<style scoped>
/* Estilos gerais */
.search-input {
  display: block;
  margin: 20px 0;
  padding: 10px;
  width: 100%;
  max-width: 400px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.icons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 120px; /* Largura mínima para evitar sobreposição */
}

.icon-item svg {
  margin-bottom: 8px;
  color: #333;
}

.icon-name {
  margin: 0;
  font-size: 14px;
  word-wrap: break-word; /* Permite quebra de linha em nomes longos */
  text-align: center; /* Centraliza o nome */
}
</style>
